import api from '../api/api-list'

const state = {
  newList: [], // 动态的列表
  newTotal: -1, // 动态的总条数
  blogList: [], // 攻略列表数据
  blogTotal: -1, // 攻略的所有数量
  // searchListAll: [],  // 搜索列表全部tag
  searchListBlog: [], // 搜索blog列表
  searchListNews: [], // 搜索动态列表
  searchNewsTotal: -1, // 搜索动态总条数
  searchBlogTotal: -1,  // 搜索攻略总条数
  messageCount: 0, // 消息通知数
  blogTags: [],
  headImages: [],
  vote: null,//投票对象。临时存储
  isShowMessageRedDot: false,
  isReflash: ''   // 点击TabBar刷新信息流页
}

const actions = {
  getUnViewCount: async function ({state, commit}) {
    try {
      let res = await api.bbs.getNoticeCount()
      if (res.code === 1000) {
        let num = state.messageCount
        commit('setUnViewCount', res.data.unviewed_count)
        commit('setRedDot', state.isShowMessageRedDot || res.data.unviewed_count > num)
      }
    } catch (e) {
      console.log(e)
    }
  },
  // 获取动态列表
  getRecommendNews: async function ({commit, state}, {refresh, payload}) {
    try {
      let res = await api.bbs.getRecommendNews({...payload, size: 10})
      if (res.code === 1000) {
        const newList = refresh ? res.data.news_li : [...state.newList, ...res.data.news_li]
        commit('setRecommendData', {list: newList, total: res.data.total_count})
      }
    } catch (e) {
      console.log(e)
    }
  },
  // 获取攻略的文章列表
  getBlogData: async function ({commit, state}, {refresh, payload}) {
    try {
      let res = await api.blog.getBlogData({...payload, size: 10})
      if (res.code === 1000) {
        const blogList = refresh ? res.data.pages : [...state.blogList, ...res.data.pages]
        commit('setBlogData', {list: blogList, total: res.data.total_count})
        commit('setBlogListOtherData', {tags: res.data.tags, images: res.data.head_pages})
      }
    } catch (e) {
      console.log(e)
    }
  },
  // 搜索动态列表
  searchNews: async function ({commit, state}, {payload, refresh}) {
    try {
      let res = await api.bbs.searchNews(payload)
      if (res.code === 1000) {
        const list = refresh ? res.data.news_li : [...state.searchListNews, ...res.data.news_li]
        commit('setSearchNews', {list, total: res.data.total_count})
      }
    } catch (e) {
      console.log(e)
    }
  },
  // 搜索攻略列表
  searchBlog: async function ({commit, state}, {payload, refresh}) {
    try {
      let res = await api.bbs.searchNews(payload)
      if (res.code === 1000) {
        const list = refresh ? res.data.news_li : [...state.searchListBlog, ...res.data.news_li]
        commit('setSearchBlog', {list, total: res.data.total_count})
      }
    } catch (e) {
      console.log(e)
    }
  },
}

const mutations = {
  // 更新刷新标识
  setReflash(state, value) {
    state.isReflash = value
  },
  // 更新动态列表
  setRecommendData(state, {list, total}) {
    state.newList = list
    if (total) state.newTotal = total
  },
  // 更新文章列表
  setBlogData(state, {list, total}) {
    state.blogList = list
    if (total) state.blogTotal = total
  },
  // 更新搜索动态
  setSearchNews(state, {list, total}) {
    state.searchListNews = list;
    state.searchNewsTotal = total;
  },
  // 更新搜索攻略
  setSearchBlog(state, {list, total}) {
    state.searchListBlog = list;
    state.searchBlogTotal = total;
  },
  // // 更新搜索全部列表
  // setSearchAllList (state, { list, total }) {
  // 	state.searchListAll = list
  // 	if (total) state.allTotal = total
  // },
  // 攻略列表tag
  setBlogListOtherData(state, {tags, images}) {
    state.blogTags = tags
    state.headImages = images
  },
  // 设置未读消息数
  setUnViewCount(state, count) {
    state.messageCount = count
  },
  setVote(state, vote) {
    state.vote = vote
  },
  setRedDot(state, bool) {
    state.isShowMessageRedDot = bool
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
